import { theme } from '@prophecy/theme';
import { Button, Stack, Text, Alert } from '@prophecy/ui-v3';
import styled from 'styled-components';

import { useGlobalVariables } from '../context/globalConfig/securedConfigHook';

const Link = styled(Button)`
  padding: 0 ${theme.spaces.x4};
  &:hover,
  &:focus,
  & {
    color: ${theme.colors.white};
  }
` as typeof Button;

const StyledAlert = styled(Alert)`
  //Time being fixing later will remove
  background: #30317c;
  color: ${theme.colors.white};
  text-align: center;
  padding: ${theme.spaces.x6} 0;
  align-items: center;
  width: 100%;
  > [aria-label='info'] {
    display: none;
  }
`;

export const HackthonBanner = () => {
  const isProfessionalEditionEnabled = useGlobalVariables().isProfessionalEditionEnabled;
  if (!isProfessionalEditionEnabled) {
    return null;
  }
  return (
    <StyledAlert icon={true} banner={true} variant='info' role='alert' tooltip={''}>
      <Stack direction='horizontal' width='100%' alignY='center' align='center' gap={theme.spaces.x10}>
        <Text level='sm'>
          Come Build With Us! Compete in the Prophecy Hackathon For Prizes →
          <Link
            size='s'
            elementType='anchor'
            variant='link'
            href=' https://www.prophecy.ai/ai-accelerated-data-prep-analysis-hackathon?utm_campaign=hackathon_apr26&utm_source=in-product&utm_content=banner'
            target='blank'
            data-test-id='learn-more'>
            Learn More
          </Link>
        </Text>
      </Stack>
    </StyledAlert>
  );
};
